export const queryKeys = {
  // Accounts
  allAccounts: 'allAccounts',

  // Events
  allEvents: 'allEvents',
  dashboardEvents: 'dashboardEvents',

  // Tasks
  allTasks: 'allTasks',
  dashboardTasks: 'dashboardTasks',

  // Contacts
  allContacts: 'allContacts',

  // Employees
  allEmployees: 'allEmployees',
  employeeUserRoles: 'employeeUserRoles',

  // Preferences
  allPreferences: 'allPreferences',

  // Task Templates
  allTaskTemplates: 'allTaskTemplates',

  // Event Templates
  allEventTemplates: 'allEventTemplates',
  allCustomFields: 'allCustomFields',

  // Email Templates
  allEmailTemplates: 'allEmailTemplates',
  generateEmailPreview: 'generateEmailPreview',
  emailTemplateRecipients: 'emailTemplateRecipients',

  // Email Data
  allEmailData: 'allEmailData',

  // User Permissions
  allUserRoles: 'allUserRoles',
  allActions: 'allActions',
  allPermissions: 'allPermissions',

  // Organization
  currentOrganization: 'currentOrganization',
  currentUser: 'currentUser',
  currentUserSettings: 'currentUserSettings',
  currentUserFilters: 'currentUserFilters',
  organizationIntegrations: 'organizationIntegrations',

  // Notes
  allNotes: 'allNotes',

  // Attachments
  allAttachments: 'allAttachments',

  // Notifications
  allNotifications: 'allNotifications',

  // Activity Logs
  allActivityLogs: 'allActivityLogs',

  // Billing Tiers
  allBillingTiers: 'allBillingTiers',

  // Dashboard
  dashboardSummary: 'dashboardSummary',

  // Calendar Integrations
  googleCalendars: 'googleCalendars',
  outlookCalendars: 'outlookCalendars',

  // Note Employee Uuids
  noteEmployeeUuids: 'noteEmployeeUuids',

  // Global Search
  globalSearch: 'globalSearch',
};
